import script from "./HomeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeView.vue?vue&type=script&lang=ts&setup=true"

import "./HomeView.vue?vue&type=style&index=0&id=e21a96ec&lang=scss"

const __exports__ = script;

export default __exports__